import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect, useCallback } from 'react';
import MaterialAutocomplete from '@material-ui/lab/Autocomplete';
import { S as SearchInput } from './SearchInput-9fbcf52e.js';
import { FormControlLabel, Checkbox } from '@material-ui/core';

function Autocomplete(_a) {
    var _b = _a.getLabel,
        getLabel = _b === void 0 ? function (result) {
        return result.name;
    } : _b,
        getResults = _a.getResults,
        _c = _a.placeholder,
        placeholder = _c === void 0 ? 'Type to search' : _c,
        optionSelected = _a.optionSelected,
        newEditableLook = _a.newEditableLook,
        additionalOptions = _a.additionalOptions,

    //
    fetchSubaccounts = _a.fetchSubaccounts;
    var _d = useState(false),
        open = _d[0],
        setOpen = _d[1];
    var _e = useState([]),
        options = _e[0],
        setOptions = _e[1];
    var _f = useState(false),
        loading = _f[0],
        setLoading = _f[1];
    var _g = useState(''),
        searchValue = _g[0],
        setSearchValue = _g[1];
    useEffect(function () {
        if (!open) {
            setOptions([]);
        }
    }, [open]);
    var triggerDataLoad = useCallback(function (filterValue) {
        setLoading(true);
        setSearchValue(filterValue);
        getResults(filterValue).then(function (results) {
            setOptions(results !== null && results !== void 0 ? results : []);
            setLoading(false);
            setOpen(true);
        });
    }, [getResults]);
    return jsxs("div", { children: [jsx(MaterialAutocomplete, { open: !!(open && searchValue), onOpen: function () {
                setOpen(true);
            }, onClose: function () {
                setOpen(false);
            }, onChange: function (event, newValue) {
                optionSelected && optionSelected(newValue);
                setSearchValue('');
            }, getOptionSelected: function () {
                return false;
            }, getOptionLabel: getLabel, options: options, loading: loading, renderInput: function (_a) {
                var inputProps = _a.inputProps,
                    InputProps = _a.InputProps;
                return jsx("div", { ref: InputProps.ref, onBlur: function () {
                        setOpen(false);
                        setSearchValue('');
                    }, onFocus: function () {
                        setOpen(true);
                    }, children: jsx(SearchInput, { placeholder: placeholder, value: searchValue, ref: inputProps.ref, autocompleteInputProps: inputProps, onFilterChange: function (value) {
                            return triggerDataLoad(value);
                        }, loading: loading, newEditableLook: newEditableLook }) });
            } }), jsx("div", { className: "space-x-4", children: additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.map(function (option) {
                return jsx(FormControlLabel, { control: jsx(Checkbox, { checked: option.value, onChange: function (_, checked) {
                            option.setValue(checked);
                            option.shouldUpdateSubaccounts && (fetchSubaccounts === null || fetchSubaccounts === void 0 ? void 0 : fetchSubaccounts());
                        }, color: "primary" }), label: option.label }, option.label);
            }) })] });
}

export { Autocomplete as A };
